<template>
  <div class="empty-state d-flex flex-column justify-content-center align-items-center">
    <div>
      <img src="../../assets/img/empty-state-graphic.png" alt="coupon empty state" />
    </div>
    <template v-if="isHomeEmptyState">
      <h3>建立你的電子優惠</h3>
      <p>立即發佈優惠券，吸引更多顧客，助你生意更上一層樓。</p>
      <div class="button-wrapper">
        <ButtonAdd @click="$router.push('coupons/add')">建立積分優惠券</ButtonAdd>
        <ButtonAdd v-if="role === 'merchant' && userClass === 'PREMIUM'"
                   @click="$router.push('paidCoupons/add')">
          建立付費優惠券
        </ButtonAdd>
      </div>
    </template>
    <template v-else>
      <h3>建立你的電子優惠</h3>
      <p>你可以在這裹建立和查看你的優惠券</p>
      <ButtonAdd @click="$router.push(`${$route.path}/add`)">建立優惠券</ButtonAdd>
    </template>
  </div>
</template>

<script>
import ButtonAdd from '@/components/button/ButtonAdd.vue';

export default {
  components: {
    ButtonAdd,
  },
  props: {
    isHomeEmptyState: Boolean,
    role: String,
    userClass: String,
  },
};
</script>

<style lang="scss" scoped>
.empty-state {
  padding: 175px;

  @include respond(phone) {
    padding-left: 3rem;
    padding-right: 3rem;
  }
}

img {
  width: 100%;
  max-width: 18vw;
  height: auto;
}

h3 {
  color: #3a4046;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 25px;
  padding-top: 30px;
  padding-bottom: 20px;
}

p {
  color: #7e8b97;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  margin-bottom: 20px;
}

.button-wrapper {
  display: flex;
  width: 350px;
  justify-content: center;
}
</style>
